/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SentToContactMethod/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SentToContactMethod({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/SentToContactMethod"
  
}) {
let signupConfirmRequestValueData = fromData.useDataFormat({ viewPath,
context: 'signup_confirm_request',
format: fromHelpers.getContactMethodValue,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 data="signup_confirm_request"
 format="./helpers.js getContactMethodValue"
 text={signupConfirmRequestValueData}
 marginTop={dtSpaceXxs}
/>
{children}
</React.Fragment>)
}